import React from 'react';
import MainCom from './MainCom';

function Communication() {
  return <MainCom />;
}

export default Communication;
